import type { MessageCatalog } from './en.js';

/** Korean — complete catalog. */
export const ko: MessageCatalog = {
  'app.name': '모두뷰어',
  'app.tagline': '받은 파일, 광고 없이 바로 보고 편집하세요.',
  'app.home.primary': '받은 파일을 광고 없이 바로 여세요.',

  'home.openFile': '파일 열기',
  'home.recentFiles': '최근 파일',
  'home.favorites': '즐겨찾기',
  'home.workInProgress': '편집 중인 파일',
  'home.recoverable': '복구할 수 있는 파일',
  'home.browseDevice': '기기에서 찾기',
  'home.settings': '설정',

  'status.checkingFile': '파일을 확인하고 있습니다',
  'status.preparingPreview': '안전한 미리보기를 준비하고 있습니다',
  'status.firstPageReady': '첫 페이지가 준비되었습니다',
  'status.loadingRemaining': '나머지 내용을 불러오고 있습니다',
  'status.readyToEdit': '편집할 수 있습니다',
  'status.limitedSupport': '이 파일은 일부만 지원됩니다',
  'status.mayBeDamaged': '파일이 손상되었거나 완전하지 않을 수 있습니다',
  'status.originalUnchanged': '원본 파일은 변경되지 않았습니다',
  'status.savedAs': '새 파일로 저장했습니다',
  'status.extracted': '압축 파일에서 꺼내 저장했습니다',

  'error.unableToRead': '이 파일을 읽을 수 없습니다.',
  'error.damagedOrIncomplete': '파일이 손상되었거나 완전하지 않을 수 있습니다.',
  'error.passwordProtected': '이 파일은 암호로 보호되어 있습니다.',
  'error.featuresUnsupported': '이 파일의 일부 기능은 지원되지 않습니다.',
  'error.permissionExpired': '파일 접근 권한이 만료되었습니다.',
  'error.reopenFromSource': '원래 앱에서 파일을 다시 열어 주세요.',
  'error.notEnoughStorage': '저장 공간이 부족합니다.',
  'error.saveFailed': '파일을 저장하지 못했습니다.',
  'error.previewFailed': '미리보기를 만들지 못했습니다.',
  'error.editsSavedTemporarily': '편집 내용이 임시로 저장되었습니다.',
  'error.originalUnchanged': '원본 파일은 변경되지 않았습니다.',
  'error.mustSaveAsNewFile': '편집한 사본은 새 파일로 저장해야 합니다.',
  'error.formattingMayNotBePreserved': '일부 고급 서식은 유지되지 않을 수 있습니다.',
  'error.formulaNotRecalculated': '이 수식은 현재 다시 계산할 수 없습니다.',
  'error.conversionRequired': '이 문서는 편집하기 전에 변환이 필요합니다.',

  'action.tryAgain': '다시 시도',
  'action.saveOriginal': '원본 저장',
  'action.openInAnotherApp': '다른 앱으로 열기',
  'action.recover': '복구',
  'action.saveAsNewFile': '새 파일로 저장',
  'action.reportError': '오류 신고',
  'action.close': '닫기',
  'action.cancel': '취소',
  'action.edit': '편집',
  'action.share': '공유',
  'action.print': '인쇄',
  'action.showDetails': '자세히 보기',

  'edit.originalProtected': '원본 파일은 변경되지 않습니다. 편집한 내용은 새 파일로 저장됩니다.',
  'edit.confirmOverwriteTitle': '원본 파일을 덮어쓸까요?',
  'edit.confirmOverwriteBody': '되돌릴 수 없습니다. 새 파일로 저장하면 원본이 그대로 남습니다.',
  'edit.fileExistsTitle': '같은 이름의 파일이 이미 있습니다',
  'edit.fileExistsBody': '다른 이름을 지정하거나, 덮어쓸 것인지 확인해 주세요.',
  'edit.lossWarningTitle': '유지되지 않을 수 있는 기능이 있습니다',
  'edit.lossWarningBody': '이 형식으로 저장하면 다음이 손실될 수 있습니다: {items}',
  'edit.autoSavedAt': '{time}에 자동 저장됨',
  'edit.saveFailedCopyKept': '저장에 실패했습니다. 편집본은 그대로 보관했습니다.',
  'edit.recoveryAvailable': '{time}의 저장되지 않은 편집 내용을 복구했습니다.',

  'detect.warning.emptyFile': '이 파일은 비어 있습니다.',
  'detect.warning.shortHead': '아직 파일의 일부만 읽었습니다.',
  'detect.warning.noSignature': '파일 내용으로는 형식을 확인할 수 없었습니다.',
  'detect.warning.extensionMismatch': '확장자와 실제 파일 내용이 일치하지 않습니다.',
  'detect.warning.mimeMismatch': '보낸 앱이 알려준 파일 형식이 실제 내용과 다릅니다.',
  'detect.warning.notTextDespiteExtension': '확장자는 텍스트인데 실제 내용은 이진 파일입니다.',
  'detect.warning.unsupportedFormat': '아직 지원하지 않는 파일 형식입니다.',
  'detect.warning.containerUnresolved': '이 파일 안에 무엇이 들어 있는지 확인하지 못했습니다.',
  'detect.warning.macrosBlocked': '이 파일에는 매크로가 있습니다. 파일 안에 그대로 두되 실행하지 않습니다.',
  'detect.warning.encrypted': '이 파일은 암호화되어 있습니다.',
  'detect.warning.sensitiveContent': '이 파일에는 인증 정보가 들어 있을 수 있습니다. 최근 파일·미리보기 이미지·오류 보고에서 제외합니다.',
  'detect.warning.executableContent': '이 압축 파일에는 실행 파일이 있습니다. 모두뷰어는 실행하지 않으며 열지도 않습니다.',

  'archive.violation.unsafePath': '이 압축 파일에는 지정한 폴더 밖으로 풀리는 항목이 있습니다.',
  'archive.violation.tooManyEntries': '이 압축 파일에는 파일이 비정상적으로 많습니다({count}개).',
  'archive.violation.expansionTooLarge': '이 압축 파일을 풀면 저장 공간을 {size} 사용합니다.',
  'archive.violation.ratioTooHigh': '압축 크기에 비해 지나치게 크게 풀리는 항목이 있습니다. 악성 압축 파일일 수 있습니다.',
  'archive.violation.encryptedEntry': '이 압축 파일은 암호로 보호되어 있습니다.',
  'archive.violation.zip64Unsupported': '아직 지원하지 않는 압축 형식 확장을 사용합니다.',
  'archive.masqueradeWarning': '문서처럼 보이지만 실제로는 실행 파일인 항목입니다.',

  'fileInfo.title': '파일 정보',
  'fileInfo.fileName': '파일 이름',
  'fileInfo.fileType': '파일 형식',
  'fileInfo.detectedMime': '감지된 MIME 타입',
  'fileInfo.fileSize': '파일 크기',
  'fileInfo.originalOrCopy': '원본 / 편집 사본',
  'fileInfo.readOnly': '읽기 전용',
  'fileInfo.editSupportLevel': '편집 지원 수준',
  'fileInfo.viewSupportLevel': '뷰잉 지원 수준',
  'fileInfo.transmittedExternally': '기기 밖으로 전송됨',
  'fileInfo.processedLocally': '이 기기에서 처리됨',
  'fileInfo.macrosBlocked': '매크로·스크립트 차단됨',
  'fileInfo.accessSource': '열린 경로',
  'fileInfo.tempLocation': '임시 사본 위치',
  'fileInfo.cacheDeletionTime': '임시 사본 삭제 예정',
  'fileInfo.lastSaved': '마지막 저장',
  'fileInfo.saveResult': '저장 결과',
  'fileInfo.validationResult': '파일 검사 결과',
  'fileInfo.passwordStatus': '암호·암호화 상태',
  'fileInfo.unsupportedSummary': '지원되지 않는 기능',
  'fileInfo.value.yes': '예',
  'fileInfo.value.no': '아니요',
  'fileInfo.value.original': '원본',
  'fileInfo.value.editedCopy': '편집 사본',
  'fileInfo.value.never': '없음',
  'fileInfo.value.unknown': '알 수 없음',

  'support.full-view': '완전 뷰잉',
  'support.standard-view': '표준 뷰잉',
  'support.text-view': '텍스트 중심 뷰잉',
  'support.full-edit': '완전 편집',
  'support.basic-edit': '기본 편집',
  'support.annotate-edit': '주석 편집',
  'support.convert-edit': '변환 후 편집',
  'support.read-only': '읽기 전용',
  'support.needs-validation': '기술 검증 필요',
  'support.commercial-license': '상용 라이선스 필요',
  'support.unsupported': '지원하지 않음',

  'viewer.zoomIn': '확대',
  'viewer.zoomOut': '축소',
  'viewer.fitWidth': '너비 맞춤',
  'viewer.fitPage': '페이지 맞춤',
  'viewer.actualSize': '실제 크기',
  'viewer.fullScreen': '전체 화면',
  'viewer.search': '검색',
  'viewer.previousResult': '이전 결과',
  'viewer.nextResult': '다음 결과',
  'viewer.rotate': '회전',
  'viewer.page': '{total}페이지 중 {current}페이지',
  'viewer.sheet': '시트',
  'viewer.slide': '{total}장 중 {current}장',
  // A word processor has no page count until it has been laid out (§16), so the
  // unit a document view counts is the paragraph.
  'viewer.paragraph': '문단',
  'viewer.entry': '항목',
  'viewer.undo': '실행 취소',
  'viewer.redo': '다시 실행',
  'viewer.darkMode': '다크 모드',

  'privacy.localOnly': '이 파일은 전부 이 기기에서 처리되었습니다.',
  'privacy.noUpload': '서버로 전송된 내용이 없습니다.',
  'privacy.consentRequired': '이 작업은 파일을 서버로 보냅니다. 동의하지 않으면 진행하지 않습니다.',
  'privacy.cacheCleared': '임시 파일을 삭제했습니다.',
};
